import { OreHeading, OreInput, OreStack } from '@edenredespana/oreneta'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { handleErrors } from '@/Shared/ui/form'
import { StoreStickersForm } from '@/Store/ui/hooks'
import { storesTranslation } from '@/Store/ui/storesTranslation'

interface StoreStickersFormGeneralProps {
  form: UseFormReturn<StoreStickersForm>
  canGetMaterials: boolean
}

export const StoreStickersFormGeneral = ({
  form: { register, formState },
  canGetMaterials,
}: StoreStickersFormGeneralProps): JSX.Element => {
  const { t } = useTranslation()

  const { errors } = handleErrors(formState)

  return (
    <OreStack placeContent="stretch" space="large">
      <OreHeading as="h2" size="headline-md">
        {t(storesTranslation.stickers.form.title1)}
      </OreHeading>
      <OreInput
        {...register('materialQuantity')}
        {...errors('materialQuantity')}
        id="quantity"
        label={t(storesTranslation.stickers.form.numberOfStickers.label)}
        placeholder={t(storesTranslation.stickers.form.numberOfStickers.placeholder)}
        required
        type="number"
        disabled={!canGetMaterials}
      />
    </OreStack>
  )
}
